import React, {useState, useEffect} from 'react';
import ResourceSectionsService, {ResourceSection} from 'src/services/ResourceSectionsService';
import Card from 'src/components/Cards/Card';
import {titleize} from 'shared/utils';
import {Link} from 'react-router-dom';

const ResourceSections = (): React.ReactElement | null => {
  const [resourceSections, setResourceSections] = useState<ResourceSection[] | null>(null);

  useEffect(() => {
    ResourceSectionsService.index().then(setResourceSections);
  }, []);

  if (!resourceSections) {
    return null;
  }

  return (
    <div>
      <h1 className="shared-font title">Resource Sections</h1>
      {resourceSections.map((resourceSection) => (
        <Link to={`/admin/tools/resource-sections/${resourceSection.id}`} key={resourceSection.id}>
          <Card>
            <div className="row">
              <div className="col-md-6">
                <h2 className="shared-font subheading">
                  {titleize(resourceSection.name.replace(/\-/g, ' '))}
                </h2>
                <p className="shared-font body">{resourceSection.description}</p>
              </div>
              <div className="col-md-6 text-right">
                <img style={{maxWidth: '200px'}} src={resourceSection.screenshot} />
              </div>
            </div>
          </Card>
        </Link>
      ))}
    </div>
  );
};

export default ResourceSections;
